const React = require('react')
const { useEffect, useState } = require('react')
const { Container, Row, Col } = require('reactstrap')
const { useParams } = require('react-router-dom')
const { useBlockchainData, useResponsive, BREAKPOINTS } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { Tabs, CopyButton, QRCodeButton } = require('@components')
const { ContractTab } = require('@components/contractTab')

const { TokenStatistics } = require('./statistics.token')
const { TokenTransfers } = require('./transfers.token')
const { TokenHolders } = require('./holders.token')
const { TokenInfo } = require('./info.token')
const { TokenInventory } = require('./inventory.token')

require('@styles/pages/address/index.css')

const Token = () => {
    const currentUrl = window.location.href
    const { address } = useParams()
    const { network } = useNetworkConfig()
    const { getAddressOverview, getTokenOverview } = useBlockchainData(network.name)

    const isMobile = useResponsive(BREAKPOINTS.small)
    const [loading, setLoading] = useState(false)
    const [addressOverviewData, setAddressOverviewData] = useState(null)
    const [tokenOverviewData, setTokenOverviewData] = useState(null)

    const [activeTab, setActiveTab] = useState(() => {
        const urlHash = window.location.hash.slice(1)

        return urlHash || 'transfers'
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)

                const [adddressOverviewResponse, tokenOverviewResponse] = await Promise.all([
                    getAddressOverview(address),
                    getTokenOverview(address)
                ])

                if (adddressOverviewResponse && tokenOverviewResponse) {
                    setAddressOverviewData(adddressOverviewResponse)
                    setTokenOverviewData(tokenOverviewResponse)
                }

                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error)
                setLoading(false)
            }
        }
        fetchData()
    }, [address])

    return (
        <div className='page'>
            <Container>
                <Col>
                    <Row>
                        <div className='page-header'>
                            <text
                                className='page-title'
                                style={isMobile ? { display: 'flex', flexDirection: 'column' } : {}}
                            >
                                Token&nbsp;
                                <span className='page-title-subcontent'>{address}&nbsp;</span>
                                <div style={{ display: 'inline-flex' }}>
                                    <span style={{ transform: 'scale(0.8)', transformOrigin: 'left' }}>
                                        <CopyButton
                                            id={`copy-address-${address}`}
                                            data={address}
                                            text={'Copy address'}
                                        />
                                    </span>
                                    <span style={{ transform: 'scale(0.8)', transformOrigin: 'left' }}>
                                        <QRCodeButton id={`qr-code-${address}`} url={currentUrl} text={address} />
                                    </span>
                                </div>
                            </text>
                            <div className='page-title-border' />
                        </div>
                    </Row>
                    <Row>
                        <TokenStatistics loading={loading} data={tokenOverviewData} />
                    </Row>
                    <div style={{ marginTop: '24px' }} />
                    <Tabs
                        activeTab={activeTab}
                        items={[
                            { tab: 'transfers', text: 'Transfers' },
                            ...(tokenOverviewData?.totalHolders > 0 ? [{ tab: 'balances', text: `Holders` }] : []),
                            { tab: 'tokenInfo', text: `Info` },
                            ...(tokenOverviewData?.tokenType !== 'ERC20' && tokenOverviewData?.totalHolders > 0
                                ? [{ tab: 'inventory', text: `Inventory` }]
                                : []),
                            // { tab: 'tokenTrade', text: `Dex Trades` },
                            { tab: 'code', text: `Contracts` }
                        ]}
                        onTabChange={setActiveTab}
                    />
                    {activeTab === 'transfers' && <TokenTransfers data={tokenOverviewData} />}
                    {activeTab === 'balances' && <TokenHolders data={tokenOverviewData} />}
                    {activeTab === 'tokenInfo' && <TokenInfo loading={loading} data={tokenOverviewData} />}
                    {activeTab === 'inventory' && <TokenInventory setActiveTab={setActiveTab} />}
                    {/* {activeTab === 'tokenTrade' && <TokenDexTrades loading={loading} data={tokenOverviewData} />} */}
                    {activeTab === 'code' && <ContractTab loading={loading} data={addressOverviewData} />}
                </Col>
            </Container>
        </div>
    )
}

module.exports = Token
